import React from 'react';
import PropTypes from 'prop-types';
import { jwtDecode } from '../../helpers/jwt';
import { Container, Icon, Button, Header} from 'semantic-ui-react';

const LoginAs = props => {
    
    const { payload } = jwtDecode(props.token);

    return (
        <Container>
            <Header as="h1" textAlign="center">Welcome Back</Header>
            <div className="login-as">
                <Header as="h2">
                    <Icon name="user" />
                    <Header.Content>{payload.email}</Header.Content>
                </Header>
                <div className="change-user">(<a href="/" onClick={props.onChangeUser}>Change User</a>)</div>
            </div>
            <Button basic fluid onClick={props.onSubmit}>CONTINUE</Button>
        </Container>
    );
};

LoginAs.propTypes = {
    onSubmit: PropTypes.func.isRequired,
    onChangeUser: PropTypes.func.isRequired,
    loading: PropTypes.bool,
    children: PropTypes.array,
    token: PropTypes.string.isRequired,
    error: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.array,
    ])
};

export default LoginAs;